import { useEffect, useState } from "react";
import { getCustomisationValue } from "../../../EditablePreview/EditablePreview";
import ModuleNumericalInput from "../../components/ModuleNumericalInput";
import { changeNumericalFieldValue, changeStringFieldValue, changeValue_noType } from "../../ModuleList";
import { renderFirstCustomBlock, renderSecondCustomBlock } from "../../customFields/CustomFieldRenderer";
import ModuleTextInput from "../../components/ModuleTextInput";
import Toggle from "../../customFields/toggle/toggleSwitch/Toggle";
import RangeSlider from "../../customFields/rangeSlider/slider/RangeSlider";
import AudioField from "../../customFields/audio/AudioField";
import DisruptorField from "../../customFields/disruptor/DisruptorField";
import { IconJsxer } from "../../../../../../../helpers/IconHelper";

const DisruptorModule = (props) => {
    const moduleConfig = props.moduleConfig;
    const customisationVars = props.customisationVars;

    // console.log("DisruptorModule: Rendering with moduleConfig:", moduleConfig, "and customisationVars:", customisationVars, props);

    const findFieldNamed = (name) => {
        if (!moduleConfig?.fields) {
            return null;
        }
        for (let i = 0; i < moduleConfig.fields.length; i++) {
            if (moduleConfig.fields[i].name === name) {
                return moduleConfig.fields[i];
            }
        }
        return null;
    };
    const findDataLinkForFieldNamed = (name) => {
        const fieldConfig = findFieldNamed(name);
        return fieldConfig?.dataLink ?? null;
    }

    const enabledDataLink = moduleConfig['disruptor-enabled'] ?? findDataLinkForFieldNamed('Enabled');
    const waitForEndDataLink = moduleConfig['disruptor-wait-for-end'] ?? findDataLinkForFieldNamed('Wait For End');
    const disruptorSelectDataLink = moduleConfig['disruptor-select'] ?? findDataLinkForFieldNamed('Disruptor');
    // console.log(enabledDataLink, disruptorSelectDataLink, waitForEndDataLink);

    const [enabled, setEnabled] = useState(getCustomisationValue(customisationVars, enabledDataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode) ?? null);
    const [disruptorSelect, setDisruptorSelect] = useState(getCustomisationValue(customisationVars, disruptorSelectDataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode) ?? null);
    const [waitForEnd, setWaitForEnd] = useState(getCustomisationValue(customisationVars, waitForEndDataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode) ?? null);

    useEffect(() => {
        if (enabledDataLink) {
            const enabledValue = getCustomisationValue(customisationVars, enabledDataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode);
            setEnabled(enabledValue);
        }
    }, [enabledDataLink, customisationVars, props.index, props.visualisationComponentKey, props.selectedFeatureNode]);
    useEffect(() => {
        if (disruptorSelectDataLink) {
            const disruptorSelectValue = getCustomisationValue(customisationVars, disruptorSelectDataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode);
            setDisruptorSelect(disruptorSelectValue);
        }
    }, [disruptorSelectDataLink, customisationVars, props.index, props.visualisationComponentKey, props.selectedFeatureNode]);
    useEffect(() => {
        if (waitForEndDataLink) {
            const waitForEndValue = getCustomisationValue(customisationVars, waitForEndDataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode);
            setWaitForEnd(waitForEndValue);
        }
    }, [waitForEndDataLink, customisationVars, props.index, props.visualisationComponentKey, props.selectedFeatureNode]);

    const changeWaitForEndFieldValue = (value) => {
        if (waitForEndDataLink) {
            if (changeValue_noType(customisationVars, { dataLink: waitForEndDataLink }, value, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode)) {
                setWaitForEnd(value);
            }
        }
    };
    /* const changeNameFieldValue = (value) => {
        if (nameDataLink) {
            if (changeStringFieldValue(customisationVars, { dataLink: nameDataLink }, value, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode)) {
                setName(value);
            }
        }
    }; */
    const changeEnabledFieldValue = (value) => {
        if (enabledDataLink) {
            if (changeValue_noType(customisationVars, { dataLink: enabledDataLink }, value, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode)) {
                setEnabled(value);
                props.forceUpdateComponent();
            }
        }
    };

    /* const clickHandler = () => {
        props.openTemporaryAudioUploadPopup(
            audioFile,
            'Timeline Audio > ' + (name || 'Unnamed Audio'),
            'This is a temporary audio uploader and is not final.',
        )
    } */

    let disruptorFieldEnabled = true;
    if (enabledDataLink && (enabled === false || enabled === null)) {
        disruptorFieldEnabled = false;
    }

    const rawDisruptorData = getCustomisationValue(customisationVars, disruptorSelectDataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode) ?? null;
    const disruptorId = typeof rawDisruptorData === 'string' ? rawDisruptorData.split(':')[0] : null;

    return (
        <div className="v2-basic-module-holder">
            <div className="fl-row">
                <h4>Disruptor</h4>
                <div className="grow"></div>
                {/* IconJsxer.GetIcon(props.visibleTriggeredDisruptorId === disruptorId ? IconJsxer.ICONS.eye : IconJsxer.ICONS.eyeSlash, IconJsxer.ICON_STYLES.headerBarButtonIcon, null, () => props.setVisibleTriggeredDisruptorId(props.visibleTriggeredDisruptorId === disruptorId ? null : disruptorId)) */}
                {/* <div className="grow"></div>
                <div className='v2-module-one-column'>
                    <div className='v2-module-field-label'>Enabled</div>
                </div>
                <div className='v2-module-one-column'>
                    <div className={`v2-field-holder${!enabledDataLink ? ' v2-module-disabled-field' : ''}`}>
                        <Toggle
                            value={enabled}
                            onToggle={enabledDataLink ? () => changeEnabledFieldValue(!enabled) : null}
                        />
                    </div>
                </div> */}
            </div>
            {renderFirstCustomBlock(props)}

            <div className='v2-module-columns-holder wrap'>

                {enabledDataLink &&
                    <div className='v2-module-one-column'>
                        <div className={`v2-module-field-label${!enabledDataLink ? ' disabled' : ''}`}>Enabled</div>
                        <div className={`v2-field-holder${!enabledDataLink ? ' v2-module-disabled-field' : ''}`}>
                            <Toggle
                                value={enabled}
                                onToggle={enabledDataLink ? () => changeEnabledFieldValue(!enabled) : null}
                            />
                        </div>
                    </div>
                }

                {waitForEndDataLink &&
                    <div className='v2-module-one-column'>
                        <div className={`v2-module-field-label${!waitForEndDataLink ? ' disabled' : ''}`}>Wait For End</div>
                        <div className={`v2-field-holder${!waitForEndDataLink ? ' v2-module-disabled-field' : ''}`}>
                            <Toggle
                                value={waitForEnd}
                                onToggle={waitForEndDataLink ? () => changeWaitForEndFieldValue(!waitForEnd) : null}
                            />
                        </div>
                    </div>
                }

                <div className='v2-module-one-column v2-full-width'>
                    <DisruptorField
                        fieldData={{ customFieldConfig: { dataLink: disruptorSelectDataLink, customFieldLabel: 'Select Disruptor' } }}
                        moduleConfig={moduleConfig}
                        groupConfig={props.groupConfig}
                        customisationVars={customisationVars}
                        campaignData={props.campaignData}
                        index={props.index}
                        visualisationComponentKey={props.visualisationComponentKey}
                        selectedFeatureNode={props.selectedFeatureNode}
                        isEnabled={!!disruptorSelectDataLink && disruptorFieldEnabled}
                        openClassicCustomisationSubsetPopup={props.openClassicCustomisationSubsetPopup}
                        getCustomisationVarsForFeature={props.getCustomisationVarsForFeature}

                        visibleTriggeredDisruptorId={props.visibleTriggeredDisruptorId}
                        setVisibleTriggeredDisruptorId={props.setVisibleTriggeredDisruptorId}
                        activateNodeFunction={props.activateNodeFunction}
                    />
                </div>

            </div>

            {renderSecondCustomBlock(props)}
        </div>
    );
};

export default DisruptorModule;
